const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.195312 4.96875 L 16.792969 0.566406 C 16.421875 0.199219 15.941406 0 15.425781 0 L 4.167969 0 C 3.101562 0 2.238281 0.863281 2.238281 1.925781 L 2.238281 22.074219 C 2.238281 23.136719 3.101562 24 4.167969 24 L 19.832031 24 C 20.898438 24 21.761719 23.136719 21.761719 22.074219 L 21.761719 6.328125 C 21.757812 5.816406 21.558594 5.332031 21.195312 4.96875 Z M 16.613281 2.277344 L 19.480469 5.140625 L 16.613281 5.140625 Z M 20.425781 22.074219 C 20.425781 22.398438 20.160156 22.664062 19.828125 22.664062 L 4.167969 22.664062 C 3.839844 22.664062 3.574219 22.398438 3.574219 22.074219 L 3.574219 1.925781 C 3.574219 1.601562 3.839844 1.335938 4.167969 1.335938 L 15.285156 1.335938 L 15.285156 5.808594 C 15.285156 6.179688 15.582031 6.476562 15.953125 6.476562 L 20.425781 6.476562 Z M 20.425781 22.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.28125 9.355469 L 8.921875 9.355469 L 6.195312 15.664062 L 7.695312 15.664062 L 8.28125 14.300781 L 10.925781 14.300781 L 11.511719 15.664062 L 13.007812 15.664062 Z M 8.8125 13.066406 L 9.609375 11.234375 L 10.390625 13.066406 Z M 8.8125 13.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 16.21875 11.945312 L 16.21875 10.320312 L 14.972656 10.320312 L 14.972656 11.945312 L 13.394531 11.945312 L 13.394531 13.054688 L 14.972656 13.054688 L 14.972656 14.679688 L 16.21875 14.679688 L 16.21875 13.054688 L 17.796875 13.054688 L 17.796875 11.945312 Z M 16.21875 11.945312 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.b71b46042ebc26116dbd5f1a284f2064.svg";
export { ForwardRef as ReactComponent };